"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatPrice = exports.default = void 0;
var formatShortPrice = num => {
  var millions = num >= 1000000;
  return {
    price: millions ? "$".concat((num / 1000000).toFixed(2)).replace(/[.0]{0,3}$/, '') : "$".concat((num / 1000).toFixed(0)),
    unit: millions ? 'M' : 'K'
  };
};
var formatPrice = exports.formatPrice = function formatPrice(num) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
  var groups = [];
  var acc = Math.floor(num);
  if (acc <= 0) {
    return '0';
  }
  while (acc > 0) {
    var group = acc % 1000;
    acc = Math.floor(acc / 1000);
    groups.push(acc > 0 ? "000".concat(group).slice(-3) : String(group));
  }
  return groups.reverse().join(separator);
};
var _default = exports.default = formatShortPrice;